<div class="td-cnt-ext">
  <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}">

    <div class="td-cnt-title">
      <i class="fal fa-file-lines dialog-icon"></i>
      <span class="te-title">{{'quotation.importFromExisting' | translate}} </span>
    </div>

    <div class="td-cnt-body-iq">

      <!-- Step 1: Select Enquiry -->
      <ng-container *ngIf="step === 1">
        <!-- <p>{{ 'quotation.selectEnquiry' | translate }}</p> -->
        <teiasoft-toolbar [buttonsList]="buttonsList" [theme]="globals.theme!" (onBtnClick)="onBtnToolbarClick($event)"
          style="width: 100%;"></teiasoft-toolbar>

        <teiasoft-grid-odata [columnsToHideGOD]="columnsToHide" [oDataUrl]="oDataUrl" [odataEntity]="'VEnquiry'"
          [sortable]="true" [theme]="globals.theme!" style="width:100%" [selectable]="false"
          [disableAllSelection]="true" [filterable]="gridFilterable" [dateFormat]="globals.dateFormat!"
          [dateTimeFormat]="globals.dateTimeFormat!" [gridConfiguration]="gridConfiguration" [autoWidth]="true"
          [paginable]="true" [customIcoCols]="customIcoCols" (customIconClick)="customIconClick($event)"
          [rowsPerPage]="50" [clearFilters]="clearFilters" [refreshGridKey]="refreshGridKey"
          [filterScope]="'ImportQuotation'" (onActiveFiltersUpdate)="onActiveFiltersUpdate($event)">
        </teiasoft-grid-odata>
      </ng-container>

      <!-- Step 2: Preview PDF -->
      <ng-container *ngIf="step === 2">
        <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="540px"></iframe>
      </ng-container>

      <!-- Step 3: Select Sections -->
      <div *ngIf="step === 3">
        <p>{{ 'quotation.selectSections' | translate }}</p>
        <div *ngFor="let section of availableSections" class="sections">
          <label>
            <input type="checkbox" [(ngModel)]="section.selected" (change)="onSectionToggle(section)">
            {{ section.label }}
          </label>
        </div>
      </div>

    </div>

    <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
      <!-- Navigation buttons -->
      <teiasoft-button *ngIf="step === 2" (onClick)="confirmPreview()" class="mr-5" [type]="'tb-primary'"
        [text]="'quotation.confirmImport' | translate" [isMobile]="isMobile">
      </teiasoft-button>

      <teiasoft-button *ngIf="step === 3" (onClick)="onImportClick()" class="mr-5" [type]="'tb-primary'"
        [text]="'quotation.import' | translate" [isMobile]="isMobile">
      </teiasoft-button>

      <teiasoft-button (onClick)="onCloseClick()" class="mr-5" [type]="'tb-cancel'"
        [text]="'commons.cancel' | translate" [isMobile]="isMobile">
      </teiasoft-button>
    </div>
  </div>
</div>
